// M23: 跨課題練習 - Cross-topic Problems
// 系統化數據結構，準備 Supabase 後端遷移

export const M23_MODULE_INFO = {
  moduleId: 'M23',
  title: '跨課題練習',
  titleEn: 'Cross-topic Problems',
  description: '綜合運用多個課題知識解決複雜問題',
  totalTopics: 10,
  estimatedTime: '12-15小時',
  difficulty: 'advanced',
  prerequisites: ['M01', 'M02', 'M04', 'M08', 'M09', 'M10', 'M13', 'M15'],
  learningObjectives: [
    '綜合運用多個數學概念',
    '分析複雜的數學問題',
    '建立跨領域數學模型',
    '提高問題解決能力',
    '準備高級數學考試'
  ]
};

export const M23_TOPICS = [
  {
    id: 'M23_01',
    name: "代數與幾何綜合",
    description: "結合代數運算和幾何概念的問題",
    order: 1,
    subTopics: [
      "解析幾何中的代數方法",
      "幾何圖形的代數表示",
      "坐標幾何與函數",
      "幾何變換的代數描述",
      "最值問題的幾何意義"
    ]
  },
  {
    id: 'M23_02',
    name: "函數與方程綜合",
    description: "函數性質與方程求解的結合",
    order: 2,
    subTopics: [
      "函數方程求解",
      "參數方程與函數",
      "函數的零點問題",
      "方程組的函數解釋",
      "函數與不等式"
    ]
  },
  {
    id: 'M23_03',
    name: "三角與向量綜合",
    description: "三角函數與向量知識的綜合應用",
    order: 3,
    subTopics: [
      "向量在三角中的應用",
      "三角恆等式的向量證明",
      "三角函數的向量表示",
      "空間向量與三角",
      "三角向量綜合應用"
    ]
  },
  {
    id: 'M23_04',
    name: "概率與統計綜合",
    description: "概率理論與統計方法的結合",
    order: 4,
    subTopics: [
      "概率分布的統計應用",
      "統計推斷中的概率",
      "數據分析與概率模型",
      "隨機變量的統計性質",
      "概率統計綜合問題"
    ]
  },
  {
    id: 'M23_05',
    name: "數列與極限綜合",
    description: "數列性質與極限概念的綜合",
    order: 5,
    subTopics: [
      "數列的極限性質",
      "級數收斂性判斷",
      "遞推數列分析",
      "數列與函數的關係",
      "無窮級數應用"
    ]
  },
  {
    id: 'M23_06',
    name: "最值優化問題",
    description: "各種數學工具在最值問題中的應用",
    order: 6,
    subTopics: [
      "函數最值問題",
      "幾何最值問題",
      "線性規劃最優化",
      "條件最值問題",
      "實際應用最值"
    ]
  },
  {
    id: 'M23_07',
    name: "應用數學建模",
    description: "實際問題的數學建模",
    order: 7,
    subTopics: [
      "物理問題數學化",
      "經濟問題建模",
      "生物數學模型",
      "社會科學建模",
      "工程技術應用"
    ]
  },
  {
    id: 'M23_08',
    name: "邏輯推理綜合",
    description: "數學邏輯與推理方法",
    order: 8,
    subTopics: [
      "數學歸納法",
      "反證法應用",
      "構造法證明",
      "邏輯等價變換",
      "命題邏輯應用"
    ]
  },
  {
    id: 'M23_09',
    name: "競賽數學技巧",
    description: "數學競賽中的解題技巧",
    order: 9,
    subTopics: [
      "巧妙換元技巧",
      "對稱性的利用",
      "極端原理應用",
      "抽屜原理技巧",
      "數形結合方法"
    ]
  },
  {
    id: 'M23_10',
    name: "綜合考試準備",
    description: "高考和升學考試的綜合準備",
    order: 10,
    subTopics: [
      "考試策略與技巧",
      "時間分配方法",
      "常見陷阱識別",
      "解題步驟規範",
      "模擬考試訓練"
    ]
  }
];

// 導出模組統計信息
export const M23_STATS = {
  totalTopics: M23_TOPICS.length,
  totalSubTopics: M23_TOPICS.reduce((sum, topic) => sum + topic.subTopics.length, 0),
  estimatedHours: 15,
  difficultyLevel: 3, // 1-3 scale
  prerequisiteModules: 8
}; 